import React from 'react';
import classNames from 'classnames';
import Plan from '../plan';
import Divider from '../../divider';
import ActionButton from '../../action-button';
import PlanRowItem from '../plan-row-item';
import PlanLabel from '../plan-label';
import noop from '../../../../utils/noop';
import HangingTag from '../hanging-tag';
const defaultCaptions = {};

const PlanMobile = ({
  captions = defaultCaptions,
  highlighted = false,
  limited = false,
  disabled = false,
  isLoading = false,
  collapsed = true,
  onPlanSelect = noop,
  onCollapseClick = noop,
  collapseOpenText = '',
  collapseHiddenText = '',
  withIntroPriceDiscounts = false,
  type = '',
  availabilities,
}) => {
  const { label, tagLabel } = captions;
  const classes = classNames('ws-ui-plan-mobile', {
    'ws-ui-plan-mobile--highlighted': highlighted,
    'ws-ui-plan-mobile--disabled': disabled,
    'ws-ui-plan-mobile--has-label': label,
    'ws-ui-plan-mobile--with-intro-discounts': withIntroPriceDiscounts,
  });

  const handleCollapseClick = () => {
    onCollapseClick(type);
  };

  return (
    <div className={classes}>
      {limited && (
        <div className="ws-ui-plan-mobile__tag-wrapper">
          <HangingTag label={tagLabel} mobileView animated />
        </div>
      )}
      <PlanLabel highlighted={highlighted} label={label} limited={limited} />
      <Plan
        limited={limited}
        captions={captions}
        isLoading={isLoading}
        disabled={disabled}
        type={type}
        onPlanSelect={onPlanSelect}
        highlighted={highlighted}
        isCompact
        withIntroPriceDiscounts={withIntroPriceDiscounts}
      />
      <div className="ws-ui-plan-mobile__body">
        {!collapsed &&
          availabilities.map(({ text, ...rest }) => (
            <PlanRowItem isCompact key={text} text={text} {...rest} />
          ))}
        <div className="ws-ui-plan-mobile__divider">
          <Divider />
        </div>
        <ActionButton
          label={collapsed ? collapseHiddenText : collapseOpenText}
          iconPlacement="after"
          format="text"
          iconGlyph={collapsed ? 'down' : 'up'}
          onClick={handleCollapseClick}
          fullWidth
        />
      </div>
    </div>
  );
};

export default PlanMobile;
